import { render } from "./FlatList.vue?vue&type=template&id=e447fdf8"
import script from "./FlatList.vue?vue&type=script&lang=js"
export * from "./FlatList.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Раиль\\Desktop\\Projects\\Mercury\\onix.plugin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__